import styled from 'styled-components'

export const StyledTitle = styled.div`
    font-size: 16px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.greyishBrown};
    margin-bottom: 15px;
    margin-left: 15px;
    margin-right: 15px;
    padding-bottom: 15px;
    border-bottom: ${ ({ theme }) => `1px solid ${theme.veryLightPink}`};
`
